import request from "@/utils/request";

// 获取围栏规则列表
export function getFenceRuleList(fenceId) {
  return request({
    url: "/open/roads/fence/rule/list?fenceId=" + fenceId,
    method: "get"
  });
}

// 保存围栏规则（新增/修改）
export function saveFenceRule(data) {
  return request({
    url: "/open/roads/fence/rule/save",
    method: "post",
    data: data
  });
}

// 删除围栏规则
export function deleteFenceRule(data) {
  return request({
    url: "/open/roads/fence/rule/delete",
    method: "post",
    data: data
  });
}
